export default "__VITE_ASSET__TRpnofOz__ 500w";